export default __webpack_public_path__ + "static/fonts/Everett-Light.32a909e.woff2";